import React from 'react'
import { Control, Controller, FieldError } from 'react-hook-form'
import {
  FormLabel,
  FormControl,
  FormHelperText,
  FormErrorMessage,
  TextareaProps,
} from '@chakra-ui/react'
import { TextAreaField } from '.'

type FieldSelectRegistryController = {
  name: string
  label?: string
  control: Control<any>
  error?: FieldError
  helperText?: string | React.ReactNode
  shouldLabelRed?: boolean
} & TextareaProps

export const TextAreaController: React.FC<FieldSelectRegistryController> = ({
  name,
  label,
  error,
  control,
  helperText,
  defaultValue,
  shouldLabelRed,
  ...rest
}) => {
  return (
    <FormControl mt="0px !important" isInvalid={!!error}>
      {label && (
        <FormLabel
          fontFamily="Mulish"
          fontStyle="normal"
          fontWeight="600"
          fontSize="16px"
          lineHeight="20px"
          textAlign="left"
          letterSpacing="0.04em"
          color={shouldLabelRed && error ? '#FF6363' : '#FFFFFF'}
          htmlFor={name}
        >
          {shouldLabelRed && error ? `${label}*` : label}
        </FormLabel>
      )}

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => <TextAreaField {...rest} {...field} />}
      />

      {helperText && (
        <FormHelperText w="full" textAlign="right">
          {helperText}
        </FormHelperText>
      )}

      {!!error && (
        <FormErrorMessage color={'red.500'}>{error.message}</FormErrorMessage>
      )}
    </FormControl>
  )
}
